/// <reference types="./previous_proposals.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $guards from "../../../../common/common/guards.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import * as $projects_table from "../../../frontend/view/components/projects_table.mjs";

export function view(model) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  let user = $state.current_user(state);
  let _block;
  let _pipe = $option.map(user, $guards.edit_proposal);
  _block = $option.unwrap(_pipe, false);
  let proposals_editable = _block;
  return $projects_table.table(
    new $projects_table.Props(
      user,
      state.proposals.more_proposal_opened,
      new $projects_table.HideMenu(),
      computed.projects.finished,
      state.opened_projects,
      proposals_editable,
      state.loading.proposals || $option.is_none(user),
      state.route,
      state.organization.users,
    ),
  );
}
